import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { fuseAnimations } from '@fuse/animations';
import {TranslateService} from '@ngx-translate/core';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import Swal from 'sweetalert2';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';
import { ModalRecoComponent } from "./modal-reco/modal-reco.component";
//SERVICE
import { SheduleService } from "../../services/shedule.service";
import { SurveyStatusService } from "app/main/pagina/tools/survey-status/survey-status.service";

@Component({
  selector: 'vista-gen',
  templateUrl: './vista-gen.component.html',
  styleUrls: ['./vista-gen.component.scss'],
  animations   : fuseAnimations
})
export class VistaGenComponent implements OnInit {

  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @ViewChild('fecRecordatorio', { read: undefined }) calReco: MatDatepicker<Date>;

  // Datos certificar vigente
  productoMedir: backInter.prodGenerico;
  //boolean paso completo
  pasoCompleto = false;

  idiomaActual:string;
  instituto: number;

  cards = catalogo.cards;
  secciones = catalogo.secciones;

  logoOK: boolean;
  reqTecOK: boolean;

  idFechaLanzamiento: string;
  fechaLanzamiento: any;
  fechasRecordatorios: any[] = [];

  numSecciones = 0;
  seccionesCompletas = 0;
  indices:any[] = [];
  creandoEncuesta: boolean;
  tamanioTagSecc: number;
  progresoEncuesta = 0;
  procesoActual: string;
  procesoFinalizado: boolean;
  procesoOK = true;

  filtroLanzamiento = (d: Date | null): boolean => {
    var moment = require('moment');
    return moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
  };
  filtroRecordatorios: any;

  //variable para medir/pulsE/focus
  seccionesHabilitadas = [
    "encuesta",
    "usuarios",
    "NPS",
    "Reactivos",
    "Demograficos",
    "Abiertas"
  ];

  hasNpsT1: boolean = false;
  hasReactT1: boolean = false;
  hasControl1: boolean = false;
  hasDemogT1: boolean = false;
  hasOpenT1: boolean = false;

  fechaCierre: any;
  fechaCierreValidacion: any;
  prorrogasEncuesta:any;
  prorrogas=false;
  cierreEditable = false;

  userData:any;
  validationUser:boolean=false;
  desbloqueoEstatus:boolean=false;

  constructor(
    private translateSrv: TranslateService,
    private dialog: MatDialog,
    private programacionService: ProgramacionService,
    private encuestaService: EncuestaService,
    private wizardService: WizardService,
    private sheduleService: SheduleService,
    private surveyServ: SurveyStatusService,
    private _snackBar: MatSnackBar,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    this.programacionService.ordenProg.subscribe( (resu) => {
      console.log("se envio orden desde navbar: ",resu);
      this.logoOK = true;
      if(this.logoOK && this.reqTecOK){
        this.cards[0].completo = true;
      }
    });
    this.cards[0].completo = false;  //se desacompleta el paso 1 de seleccion de fecha

    if(localStorage.getItem('userBypass')){
    this.userData=JSON.parse(localStorage.getItem('userBypass'));
    // console.log(this.userData.level);
    if(this.userData.level==3 || this.userData.level==2){
      this.validationUser=true;
    }
    else{
      this.validationUser=false;
    }
    }
  }

  ngOnInit() {
    this.obtieneCertificarActual();
    this.getFechaLanzamiento();
    this.getestatusSecciones();
    this.getEstatusEncuesta();
    this.prerequisitos();
    this.getProrrogasFechasCierre();
    // this.setProductos();
  }

  irPaso(numPaso: number){
    this.cambiaPaso.emit(numPaso);
  }

  cargaLogoEmpresa(){
    this.programacionService.enviaNavbar("hola prro");
  }

  preCrearEncuesta(){
    if(this.logoOK && this.reqTecOK && this.fechaLanzamiento){
      // let texto = "¿Desea crear la encuesta con la configuración actual?\n\nUna vez creada la encuesta, no podrá modificar los mensajes de comunicación.";
      // let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
      let rspSi = 'MODALES.ACCIONES.aceptar';
      let rspNo = 'MODALES.ACCIONES.cancelar';
      // this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
      Swal.fire({
        title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREAR_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREAR_2'),
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.crearEncuesta();
          // this.crearEncuestaBack();
        }
      });
    }
    else{
      if(!this.logoOK){
        this.mensajeSwal(this.translateSrv.instant('SHEDULE.SUBIRLOGO'),3);
      }
      else if(!this.reqTecOK){
        this.mensajeSwal(this.translateSrv.instant('SHEDULE.ACEPTARREQUERIMIENTOS'),3);
      }
      else if(!this.fechaLanzamiento){
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.SINFECHA'),3);
      }
    }
  }

  crearEncuestaBack(){
    this.reiniciarVariables();
    this.secciones.forEach((seccion,i) => {
      if(seccion.visible){
        this.numSecciones++;
        this.indices.push(i);
      }
    });
    this.tamanioTagSecc = 100 / this.numSecciones;
    console.log("numsecciones:",this.numSecciones," | tamaniotag:",this.tamanioTagSecc," | progresoInicial:",this.progresoEncuesta);

    this.creandoEncuesta = true;
    this.procesoActual = this.secciones[0].proceso;

    //seccion error
    let secErr = Math.floor(Math.random() * (this.numSecciones - 1 + 1)) + 1;
    let esperaImg = setInterval(() => {
      this.procesoActual = "";

      if(this.seccionesCompletas == this.numSecciones){
        this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
        setTimeout(() => {
          this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_2'),1);
        }, 200);
        console.log("secciones completas:",this.seccionesCompletas," | progreso:",this.progresoEncuesta);
        clearInterval(esperaImg);
        this.procesoFinalizado = true;
      }
      else{
        if(this.seccionesCompletas == 0){
          this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
        }
        else{
          this.progresoEncuesta += this.tamanioTagSecc;
        }
        //prueba de una seccion con fallo
        if(this.seccionesCompletas == secErr){
          this.secciones[this.indices[this.seccionesCompletas]].fallo = true;
          // if(this.secciones[this.indices[this.seccionesCompletas+1]]){
            setTimeout(() => {
              this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].error;
            }, 200);
          // }
          clearInterval(esperaImg);
          this.procesoFinalizado = true;
          this.procesoOK = false;
        }
        else{
          this.secciones[this.indices[this.seccionesCompletas]].completo = true;
          if(this.secciones[this.indices[this.seccionesCompletas+1]]){
            setTimeout(() => {
              this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].proceso;
            }, 200);
          }
          else{
            setTimeout(() => {
              this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
            }, 200);
          }
          this.seccionesCompletas++;
          console.log("secciones completas:",this.seccionesCompletas," | progreso:",this.progresoEncuesta);
        }

      }
		}, 2000);
  }

  reiniciarVariables(){
    this.secciones.forEach(seccion => {
      seccion.completo = false;
      seccion.fallo = false;
    });
    this.tamanioTagSecc = 0;
    this.progresoEncuesta = 0;
    this.procesoActual = "";
    this.procesoFinalizado = false;
    this.procesoOK = true;
  }

  traduceTextosTS(){
    // switch(this.translateSrv.currentLang){
    //   case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
    //   default: this.idiomaActual = 'en';
    // }
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    if(tipoMsg == 1){
      this.openSnackBar(mensaje,"OK");
    }else{
      Swal.fire({
        title: mensaje,
        icon: tipo,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  verFechas(){
    const dialogRef = this.dialog.open(ModalRecoComponent, {
      width: '50%',
      data: {
        tipo: 'fechas',
        cierreEditable: this.cierreEditable,
        pasoCompleto: this.pasoCompleto,
        instituto: this.instituto
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      /*if(result == undefined){
        this.cards[1].completo = false;
      }
      else{
        this.cards[1].completo = result;
      }*/
      if(!this.cards[0].completo){
        if(result == undefined){
          this.cards[0].completo = false;
        }
        else{
          // this.cards[0].completo = result.status; /*verificar si es requerida
          this.fechaLanzamiento = result.fechaLanzamiento;
          this.fechaCierre = result.fechaCierre;
          this.setFiltroRecordatorios();
          // this.cuentaRegresiva();
        }
      }
      else{
        if(result != undefined){
          this.fechaLanzamiento = result.fechaLanzamiento;
          this.fechaCierre = result.fechaCierre;
          this.setFiltroRecordatorios();
          // this.cuentaRegresiva();
        }
      }
    });
  }
  setFiltroRecordatorios(){
    this.filtroRecordatorios = (d: Date | null): boolean => {
      var moment = require('moment');
      var fecha = new Date(this.fechaLanzamiento.replace(/-/g, '\/').replace(/T.+/, ''));
      const diaInicial = moment(fecha);
      const diaFinal = moment(this.fechaCierre);
      const diaActual = moment(d || new Date());
      let esRecordatorio: boolean;
      let BreakException = {};
      try {
        this.fechasRecordatorios.forEach( (reco) => {
          if(moment(reco).utc(true).format('YYYY-MM-DD') == moment(d || new Date()).format('YYYY-MM-DD')){
            esRecordatorio = true;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal) && !esRecordatorio;
    };
  }

  verProrrogas(){
    const dialogRef = this.dialog.open(ModalRecoComponent, {
      width: '50%',
      data: {
        tipo: 'prorrogas',
        prorrogas: this.prorrogasEncuesta
      }
    });
  }

  /*fechaSeleccionada(origen:number, event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    let moment = require('moment');

    if(origen == 1){
      console.log("Registra la fecha");
      // this.registerDate(date.getFullYear()+'-'+mnth+'-'+day);
      this.registraFechaLanzamiento(moment(fechaElegida).format('YYYY-MM-DD'));
    }
    else if(origen == 2){
      if(this.fechaLanzamiento){
        if(!this.fechasRecordatorios.includes( moment(fechaElegida).format('MM/DD/YYYY') )){
          console.log("registra el recordatorio");
          //this.registerRecordatorio(date,date);
          this.guardaRecordatorio(fechaElegida);
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOEXIS'), 3);
        }
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
      }
    }
  }*/

  fechaSeleccionada(origen:number, event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    let moment = require('moment');

    if(origen == 1){
      console.log("Registra la fecha");
      // this.registerDate(date.getFullYear()+'-'+mnth+'-'+day);
      this.registraFechaLanzamiento(moment(fechaElegida).format('YYYY-MM-DD'));
    }
    else if(origen == 2){
      if(this.fechaLanzamiento){
        if(!this.fechasRecordatorios.includes( moment(fechaElegida).format('MM/DD/YYYY') )){
          console.log("registra el recordatorio");
          //this.registerRecordatorio(date,date);
          this.guardaRecordatorio(fechaElegida);
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOEXIS'), 3);
        }
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
      }
    }
  }

  registraFechaLanzamiento(fecha){
    console.log(fecha);

    const moment = require('moment');
    let data={
      productoId : localStorage.getItem('productoID'),
      fechaLanzamiento: fecha
    };
    console.log("Data a registrar",data);

    let hoy = moment();
    let fechaElegida = moment(fecha);
    console.log("diferencia de dias",fechaElegida.diff(hoy,'days'));

    if(localStorage.getItem('instituto') == '1' || localStorage.getItem('instituto') == 'MX'){
      if(fechaElegida.diff(hoy,'days') < 15){
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.LESSDAYS_T'),
          text: this.translateSrv.instant('SHEDULE.LESSDAYS_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            Swal.fire({
              title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
              text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
              icon: 'warning',
              showCancelButton: true,
reverseButtons: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
              cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
            }).then((result) => {
              if (result.value) {
                this.guardaFechaLanzamiento(data);
              }
            });
          }
        });
      }
      else{
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
          text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            this.guardaFechaLanzamiento(data);
          }
        });
      }
    }
    else{
      Swal.fire({
        title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
        text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
        cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
      }).then((result) => {
        if (result.value) {
          this.guardaFechaLanzamiento(data);
        }
      });
    }
  }

  guardaFechaLanzamiento(data:any){
    console.log("datosAGuardar:",data);
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.SAVELAUNCHDATE'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.encuestaService.registerDate2(data).subscribe((respuesta:any) => {
      console.log("respGuardaLanz",respuesta);
      if(respuesta.message == '200'){
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE.DATE_REGISTERED'),this.translateSrv.instant('ALERTS.OK'));
        this.idFechaLanzamiento = respuesta.fechas._id;
        this.fechaLanzamiento = respuesta.fechas.fechaLanzamiento;
        this.filtroRecordatorios = (d: Date | null): boolean => {
          var moment = require('moment');
          const diaInicial = moment(this.fechaLanzamiento);
          const diaFinal = moment(this.fechaLanzamiento).add(21,'days');
          const diaActual = moment(d || new Date());
          return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
        };
        this.cards[0].completo = true;
        console.log("se volvio true cards 0 en guardaFecha");

        this.getFechaLanzamiento();

      }
      console.log("listaCards:",this.cards);
    }, error => {
      console.log(error);
    });

  }

  /*registraFechaLanzamiento(fecha){
    const moment = require('moment');
    let data={
      productoId : localStorage.getItem('productoID'),
      fechaLanzamiento: fecha
    };
    console.log("Data a registrar",data);

    let hoy = moment();
    let fechaElegida = moment(fecha);
    console.log("diferencia de dias",fechaElegida.diff(hoy,'days'));

    if(localStorage.getItem('instituto') == '1' || localStorage.getItem('instituto') == 'MX'){
      if(fechaElegida.diff(hoy,'days') < 15){
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.LESSDAYS_T'),
          text: this.translateSrv.instant('SHEDULE.LESSDAYS_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            Swal.fire({
              title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
              text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
              icon: 'warning',
              showCancelButton: true,
reverseButtons: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
              cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
            }).then((result) => {
              if (result.value) {
                this.guardaFechaLanzamiento(data);
              }
            });
          }
        });
      }
      else{
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
          text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            this.guardaFechaLanzamiento(data);
          }
        });
      }
    }
    else{
      Swal.fire({
        title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
        text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
        cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
      }).then((result) => {
        if (result.value) {
          this.guardaFechaLanzamiento(data);
        }
      });
    }
  }*/

  /*guardaFechaLanzamiento(data:any){
    console.log("datosAGuardar:",data);
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.SAVELAUNCHDATE'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.programacionService.guardaFechaProgramacionMedir(data).subscribe((respuesta: any) => {
      console.log("respGuardaLanz",respuesta);
      if(respuesta.message == '221'){
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE.DATE_REGISTERED'),this.translateSrv.instant('ALERTS.OK'));
        this.idFechaLanzamiento = respuesta.programacion._id;
        this.fechaLanzamiento = respuesta.programacion.fechaLanzamiento;
        this.fechaCierre = respuesta.programacion.fechaCierre;
        this.filtroRecordatorios = (d: Date | null): boolean => {
          var moment = require('moment');
          const diaInicial = moment(this.fechaLanzamiento);
          const diaFinal = moment(this.fechaLanzamiento).add(21,'days');
          const diaActual = moment(d || new Date());
          return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
        };
        this.cards[1].completo = true;
        console.log("se volvio true cards 0 en guardaFecha");

      }
      console.log("listaCards:",this.cards);
    }, error => {
      console.log(error);
    });

  }*/

  selRecordatorio(){
    if(this.fechaLanzamiento){
      if(this.fechasRecordatorios.length < 3){
        this.calReco.open();
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOMAX'), 2);
      }
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
    }
  }

  guardaRecordatorio(fecha){
    let moment = require('moment');
    let data: any = {
      productoId : localStorage.getItem('productoID'),
      fechaRecordatorio: fecha
    };
    this.programacionService.guardaFechaProgramacionMedir(data).subscribe((respuesta: any) => {
      console.log("guardaReco",respuesta);
      if(respuesta.message == '220'){
        this.openSnackBar(this.translateSrv.instant('SHEDULE.REMIDEROK'),this.translateSrv.instant('ALERTS.OK'));
        this.fechasRecordatorios.push( moment(fecha).format('MM/DD/YYYY') );
        if(this.fechasRecordatorios.length == 3){
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.LASTRECO_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.LASTRECO_2'), 2);
        }
      }
    });
  }

  verRecordatorios(){
    if(this.fechaLanzamiento){
      const dialogRef = this.dialog.open(ModalRecoComponent, {
        width: '50%',
        data: {
          tipo: 'recordatorios',
          fechasRecordatorios: this.fechasRecordatorios
        }
      });
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.LISTARECOBEF'), 3);
    }
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.programacionService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsMedir:backInter.prodGenerico[] = data.productosMedir2;
      var BreakException = {};
      try {
        prodsMedir.forEach( (producto) => {
          let fecha = producto.fechaProducto;
          let idProducto = producto.idProducto;
          if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
            this.productoMedir = producto;
            this.getEstatusDesbloqueo();
            throw BreakException;
          }
        });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.programacionService.getStatusProgramacionMedir(this.productoMedir.idProducto).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;
      });
      this.getStatusModal();
      this.getInstituto();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoMedir.idProducto).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 1; break;
      case '2': case 'CAyC': this.instituto = 2; break;
      case '3': case 'HK': this.instituto = 3; break;
      case '4': case 'SGP': this.instituto = 4; break;
      case '5': case 'TK': this.instituto = 5; break;
      case '6': case 'FL': this.instituto = 6; break;
      case '8': case 'IZZI': this.instituto = 8; break;
      case '11': case 'BR': this.instituto = 11; break;
    }
    this.filtraInstitutoVisible();
  }

  filtraInstitutoVisible(){
    // let institutosPermitidos = [1];
    let institutosPermitidos = [2,3,4,5,6,11];
    if(institutosPermitidos.includes(this.instituto)){
      // this.cards[2].visible = true;
      this.cierreEditable = true;
    }
  }

  getStatusModal(){
    let datos={
      productoId: this.productoMedir.idProducto,
      programacion: 1
    };
    this.wizardService.getStatusModalMedir(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('PROGRAMACION');
      }
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      inputValidator: (result)=>{
        return new Promise((resolve)=>{
          if (result){
            this.updateStatusModal();
          }
          resolve(result);
        });
      },
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    })
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoMedir.idProducto,
      programacion: 2
    };
    this.wizardService.updateStatusModalMedir(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  getFechaLanzamiento(){
    const moment = require('moment');
    let datos: any = {
      productoId: localStorage.getItem('productoID')
    };
    this.programacionService.getFechasProgramacionMedir(datos).subscribe((respuesta: backInter.getFechasMedir) => {
      console.log("respGetLanza",respuesta);
      if(respuesta.success){
        this.idFechaLanzamiento = respuesta.fechas._id;
        this.fechaLanzamiento = respuesta.fechas.fechaLanzamiento;
        this.fechaCierre = respuesta.fechas.fechaCierre;
        this.fechaCierreValidacion=moment(this.fechaCierre).format('YYYY-MM-DD');
        this.filtroRecordatorios = (d: Date | null): boolean => {
          var fecha = new Date(this.fechaLanzamiento.replace(/-/g, '\/').replace(/T.+/, ''));
          const diaInicial = moment(fecha);
          const diaFinal = moment(this.fechaLanzamiento).add(21,'days');
          const diaActual = moment(d || new Date());
          return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
        };
        this.cards[1].completo = true;
        // this.getAvisos();
        console.log("se volvio true cards 0 en getFechalanza");

        // this.getRecordatorios();
        respuesta.fechas.recordatorios.forEach(recordatorio => {
          this.fechasRecordatorios.push( moment(recordatorio.fechaRecordatorio).format('MM/DD/YYYY') );
        });
      }
      console.log("listaCards:",this.cards);
    }, error => {
      //console.log(error);
    });
  }

  getRecordatorios(){
    let moment = require('moment');
    let data: any = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    };
    this.sheduleService.getRecordatorios(data).subscribe((respuesta:any) => {
      console.log("respGetReco",respuesta);
      if(respuesta.message == '200'){
        respuesta.recordatoriosMostrar.forEach(recordatorio => {
          this.fechasRecordatorios.push( moment(recordatorio.fechaRecordatorio).format('MM/DD/YYYY') );
        });
      }
    }, error => {
      console.log(error);
    });
  }

  // getAvisos(){
  //   this.encuestaService.getAviso().subscribe((respuesta:any) => {
  //     console.log("getAviso:",respuesta);
  //     if(respuesta.success){
  //       if(respuesta.aviso1){
  //         this.cards[1].completo = true;
  //       }
  //       else if(!respuesta.aviso1){
  //         this.cards[1].completo = false;
  //       }
  //       if(respuesta.aviso2){
  //         this.cards[1].completo = true;
  //       }
  //       else if(!respuesta.aviso2){
  //         this.cards[1].completo = false;
  //       }
  //     }
  //     else{
  //       this.cards[1].completo = false;
  //     }
  //   });
  // }

  // setProductos(){
  //   let nombresT2 = {
  //     npsT1:'NPS',
  //     reactivosT1: 'Reactivos',
  //     control1: 'Control',
  //     demogT1: 'Demograficos',
  //     abiertasT1: 'Abiertas',
  //   }
  //
  //   let datos = { productoId: localStorage.getItem('productoID') };
  //   this.wizardService.getSeccionesCertificar(datos).subscribe((data:backInter.getSecciones) => {
  //     console.log("getSeccionesSetProd:",data);
  //     // if(data.success){
  //     //   data.secciones.forEach( (seccion) => {
  //     //     switch(seccion.nombre){
  //     //       case nombresT2.npsT1: this.hasNpsT1=seccion.estatus;// NPS break;
  //     //       case nombresT2.reactivosT1: this.hasReactT1 = seccion.estatus; break;
  //     //       case nombresT2.control1: this.hasControl1 = seccion.estatus; break;
  //     //       case nombresT2.demogT1: this.hasDemogT1 = seccion.estatus; break;
  //     //       case nombresT2.abiertasT1: this.hasOpenT1 = seccion.estatus; break;
  //     //     }
  //     //   });
  //     // }
  //   });
  // }

  getestatusSecciones(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    // this.encuestaService.getStatusSecciones(data).subscribe((response:any) => {
    this.wizardService.getSeccionesCertificar(data).subscribe((response:backInter.getSecciones) => {
      console.log("respGetSecc",response);
      this.secciones.forEach(seccion => {
        var BreakException = {};
        try {
          response.secciones.forEach( (seccionAgregada) => {
            if(seccion.id == seccionAgregada.nombre){
              seccion.visible = seccionAgregada.estatus;
              throw BreakException;
            }
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        };
      });
      this.secciones.forEach(seccion => {
        if(!this.seccionesHabilitadas.includes(seccion.id)){
          seccion.visible = false;
        }
      });
      console.log("Secciones Tras filtro:",this.secciones);

    }, error => {
      console.log(error);
    });
    // this.secciones.forEach(seccion => {
    //   if(this.seccionesHabilitadas.includes(seccion.id)){
    //     seccion.visible = true;
    //   }
    //   else{
    //     seccion.visible = false;
    //   }
    // });
    // console.log("Secciones Tras filtro:",this.secciones);
  }

  getEstatusEncuesta(){
    // let data = {
    //   fechaCertificar: localStorage.getItem('fechaProducto')
    // };
    // this.encuestaService.getEstatusEncuesta(data).subscribe((respuesta: backInter.getEstatusEncuesta) => {
    let data = {
      productoId: localStorage.getItem('productoID')
    };
    this.encuestaService.getEstatusEncuestaMedir(data).subscribe((respuesta: backInter.getEstatusEncuesta) => {
      console.log("getStatEnc",respuesta);

      if(respuesta.success){
        if(respuesta.survey){
          this.procesoFinalizado = true;
          this.procesoOK = true;
          this.progresoEncuesta = 100;
          this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
        }
        this.secciones.forEach(seccion => {
          seccion.completo = true;
          switch (seccion.id) {
            case 'NPS':
              seccion.visible = respuesta.nps;
            break;
            case 'Reactivos':
              seccion.visible = respuesta.reactivos;
            break;
            case 'Control':
              seccion.visible = respuesta.control;
            break;
            case 'Demograficos':
              seccion.visible = respuesta.demograficos;
            break;
            case 'Abiertas':
              seccion.visible = respuesta.abiertas;
            break;
            case 'Forall':
              seccion.visible = respuesta.forall;
            break;
            case 'Adicionales':
              seccion.visible = respuesta.adicionales;
            break;
          }
        });
      }
    }, error => {
      console.log(error);
    });
  }

  prerequisitos(){
    let datos = {
      productoId: localStorage.getItem('productoID')
    };
    this.encuestaService.getBanderas(datos).subscribe((respuesta:backInter.statusReqTec) => {
      console.log("getPreReq",respuesta);
      if(respuesta.success){
        this.logoOK = respuesta.logo;
        this.reqTecOK = respuesta.requerimientos;
        if(this.logoOK && this.reqTecOK){
          this.cards[0].completo = true;
        }
      }
    }, error => {
      console.log(error);
    });
  }

  verSeccionesAgregadas(){
    this.creandoEncuesta = !this.creandoEncuesta;
  }

  crearEncuesta(){
    this.reiniciarVariables();
    this.secciones.forEach((seccion,i) => {
      if(seccion.visible){
        this.numSecciones++;
        this.indices.push(i);
      }
    });
    this.tamanioTagSecc = 100 / this.numSecciones;
    console.log("numsecciones:",this.numSecciones," | tamaniotag:",this.tamanioTagSecc," | progresoInicial:",this.progresoEncuesta);

    this.creandoEncuesta = true;
    this.procesoActual = this.secciones[0].proceso;

    let data = {
      productoId: localStorage.getItem('productoID')
    };
    this.pasoEncuesta(data);
  }
  //PASOS CREACION DE ENCUESTA

  pasoEncuesta(data:any){
    this.sumaProgresoProceso();
    this.encuestaService.crearEncuesta_Medir(data).subscribe((respuesta:any) => {
      console.log("pasoEncuesta:",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.pasoUsuarios(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoUsuarios(data:any){
    this.sumaProgresoProceso();
    this.encuestaService.saveUsuarios_Medir(data).subscribe((respuesta:any) => {
      console.log('pasoUsuarios',respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoNPS(data:any){
    this.sumaProgresoProceso();
    let dataNps = {
      productoId: localStorage.getItem('productoID'),
      seccion: 1
    };
    this.encuestaService.saveNPSCONTROL_MedirGen(dataNps).subscribe((respuesta:any) => {
      console.log('pasoNPS',respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoReactivos(data:any){
    this.sumaProgresoProceso();
    this.encuestaService.saveReactivos_MedirGen(data).subscribe((respuesta:any) => {
      console.log('pasoReactivos',respuesta);
      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoControl(data:any){
    this.sumaProgresoProceso();
    let dataControl = {
      productoId: localStorage.getItem('productoID'),
      seccion: 3
    };
    this.encuestaService.saveControl_Medir(dataControl).subscribe((respuesta:any) => {
      console.log("pasoControl",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoDemograficos(data:any){
    this.sumaProgresoProceso();
    this.encuestaService.saveDemograficos_MedirGen(data).subscribe((respuesta:any) => {
      console.log("pasoDemograficos",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  // pasoAdicionales(data:any){
  //   this.sumaProgresoProceso();
  //   this.encuestaService.saveAdicionales_Medir(data).subscribe((respuesta:any) => {
  //     console.log("pasoAdicionales",respuesta);
  //
  //     if(respuesta.success == true){
  //       this.pasoCorrecto();
  //       this.siguientePaso(data);
  //     }else{
  //       this.pasoFallido();
  //     }
  //
  //   }, error => {
  //     this.pasoFallido();
  //     console.log(error);
  //   });
  // }
  // pasoForall(data:any){
  //   this.sumaProgresoProceso();
  //   this.encuestaService.saveForall_Medir(data).subscribe((respuesta:any) => {
  //     console.log("pasoForall",respuesta);
  //
  //     if(respuesta.success == true){
  //       this.pasoCorrecto();
  //       this.siguientePaso(data);
  //     }else{
  //       this.pasoFallido();
  //     }
  //
  //   }, error => {
  //     this.pasoFallido();
  //     console.log(error);
  //   });
  // }
  pasoAbiertas(data:any){
    this.sumaProgresoProceso();
    this.encuestaService.saveAbiertas_MedirGen(data).subscribe((respuesta:any) => {
      console.log("pasoAbiertas",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }

  sumaProgresoProceso(){
    if(this.seccionesCompletas == 0){
      this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
    }
    else{
      this.progresoEncuesta += this.tamanioTagSecc;
    }
  }

  pasoCorrecto(){
    this.secciones[this.indices[this.seccionesCompletas]].completo = true;
    if(this.secciones[this.indices[this.seccionesCompletas+1]]){
      setTimeout(() => {
        this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].proceso;
      }, 200);
    }
    else{
      setTimeout(() => {
        this.procesoActual = "SHEDULE2_0.SECCIONES.DETALLES";
      }, 200);
    }
    this.seccionesCompletas++;
    this.checkFinProceso();
  }

  siguientePaso(data:any){
    if(this.indices[this.seccionesCompletas]){
      switch (this.secciones[this.indices[this.seccionesCompletas]].id) {
        case 'NPS':

          this.pasoNPS(data);
        break;
        case 'Reactivos': this.pasoReactivos(data); break;
        case 'Control': this.pasoControl(data); break;
        case 'Demograficos': this.pasoDemograficos(data); break;
        case 'Abiertas': this.pasoAbiertas(data); break;
        // case 'Forall': this.pasoForall(data); break;
        // case 'Adicionales': this.pasoAdicionales(data); break;
      }
    }
  }

  pasoFallido(){
    this.secciones[this.indices[this.seccionesCompletas]].fallo = true;
    setTimeout(() => {
      this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].error;
    }, 200);
    this.procesoFinalizado = true;
    this.procesoOK = false;
  }

  checkFinProceso(){
    if(this.seccionesCompletas == this.numSecciones){
      this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
      setTimeout(() => {
        this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_2'),1);
      }, 200);
      this.procesoFinalizado = true;
    }
  }

  completarPaso(){
    if(this.pasoCompleto){
      let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
      this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: ['background-red']
      });
      //this.aletaRestric('PROGRAMACION.COMPLETADO',null,'warning');
    }else{
      if(this.procesoFinalizado && this.procesoOK){
        this.aletaRestric('PROGRAMACION.COMPLETAR',true);
      }
    }

  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  desbloquearProgramacion(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.TITULO_DESBLOQUEAR2';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          this.programacionService.DesbloquearPasoProgramacionMedir(localStorage.getItem('productoID')).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '215'){
               this.pasoCompleto = false;
               this.openSnackBar(succes,"OK");
               this.enviaOrdenWizard();
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,
               
               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,
        
        confirmButtonText: cerrar,
        })
      }
  }
  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          // this.programacionService.guardaStatusProgramacion(this.productoMedir.fechaCertificar).subscribe( (data: backInter.RespuestaGen) => {
          //   if(data.message == '215'){
          //     this.aletaRestric('PROGRAMACION.'+data.message,null,'success');
          //     this.pasoCompleto = true;
          //     this.enviaOrdenWizard();
          //   };
          // });
          this.programacionService.guardaStatusProgramacionMedir(localStorage.getItem('productoID')).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '215'){
              //this.aletaRestric('PROGRAMACION.'+data.message,null,'success');
              let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.215";
              this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
              this.openSnackBar(textoMensaje,"OK");
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }

  updatefechaCierre(fecha){
    let texto = 'SHEDULE.WARNING_FECHA_UPDATE';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    let textoWarning = 'SHEDULE.FECHA_UPDATE_WARNING';
    let textoSuccess = 'SHEDULE.FECHA_UPDATE';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    this.translateSrv.get(textoWarning).subscribe((res: string) => { textoWarning = res; });
    this.translateSrv.get(textoSuccess).subscribe((res: string) => { textoSuccess = res; });

    let moment = require('moment');
    let fechaActual=moment(fecha.value).format('YYYY-MM-DD');
    console.log(fechaActual);
  if (fechaActual < this.fechaCierreValidacion) {


    Swal.fire({
      icon: 'warning',
      text: texto,
      showCancelButton: true,
reverseButtons: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: rspSi,
    })
  }else{


    Swal.fire({
      title: textoWarning,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      
      
      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        let datos:any={} as backInter.updateFechaCierre;
        datos.productoId=localStorage.getItem('productoID');
        datos.empresaId=localStorage.getItem('companyID');
        datos.fecha=fechaActual;
console.log(datos);

    this.programacionService.updateFechaCierreUsuarioEmpresa(datos).subscribe((data: any) => {
          console.log(data);
          this.getFechaLanzamiento();
          if (data.success==true) {
            this.openSnackBar(texto,"OK");
            /*Swal.fire({
              icon: 'success',
              text: textoSuccess,
              showCancelButton: true,
reverseButtons: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: rspSi,
            })*/


          }


          });
      }
    });
  }


  }

  getProrrogasFechasCierre(){
  this.surveyServ.getProrrogasFechaCierre(localStorage.getItem('productoID')).subscribe( (data: any) => {
    console.log(data);
    this.prorrogasEncuesta=data.result;
    console.log(this.prorrogasEncuesta);

    if (this.prorrogasEncuesta.length>0) {
      this.prorrogas=true;
    }


  });

  }

}
